import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useState } from "react";
import { BannerCouponName, UpgradeDialogSource } from "schemas/dashboard";

import StyledBanner from "components/Styled/Banner";
import ReferralDialogNavigation from "features/Home/ReferralDialog/navigation";
import { NEW_USER_REFERRAL_CREDIT } from "utils/influencer";
import { isNewOrg } from "utils/time";
import { trackEvent } from "utils/tracking";

const SpecialAnnouncementCard = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);

  if (
    subscription?.bannerPromoCode?.couponName ===
    BannerCouponName.end_of_year_sale
  ) {
    return (
      <StyledBanner
        snippet="💥 New Year Promo"
        title="Get 30% off your Bento Subscription before Jan 10, 2026!"
        description="Choose an annual plan to amplify your savings."
        buttonText="Upgrade"
        handleClick={() => {
          setUpgradeDialogSource(
            UpgradeDialogSource.end_of_year_sale_home_page,
          );
        }}
      />
    );
  } else if (isNewOrg(currentOrg)) {
    return (
      <>
        <StyledBanner
          snippet="🥳 New User Promo"
          title="Get 4x Bento credits for any new referral during your first 2 weeks on Bento!"
          description={
            <>
              {" "}
              Give ${NEW_USER_REFERRAL_CREDIT} to a new user. Get $
              {NEW_USER_REFERRAL_CREDIT} when they subscribe. Credits will be
              auto-applied towards your next invoice.
            </>
          }
          buttonText="Start Referring"
          handleClick={() => {
            trackEvent("Referral Promo Button Clicked");
            setNavigationReferDialog(true);
          }}
        />
        <ReferralDialogNavigation
          open={navigationReferDialog}
          close={() => setNavigationReferDialog(false)}
          source="Referral Promo Button Clicked"
        />
      </>
    );
  } else {
    return <></>;
  }
};

export default SpecialAnnouncementCard;
